import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'verde' | 'gold';
};
export function CTAButton({
  children,
  className = '',
  href = 'https://megapack-universitario-elite.impultienda.ar/checkout',
  size = 'lg',
  variant = 'verde'
}: Props) {
  const pad = size === 'lg' ? 'px-8 text-[18px] pt-[17px] pb-[17px]' : 'px-6 text-base pt-[14px] pb-[14px]';
  const skin = variant === 'gold' ? 'bg-gold text-ink shadow-[0_10px_40px_-8px_rgba(229,185,75,0.6)] ring-1 ring-gold-soft/60 hover:bg-gold-soft hover:shadow-[0_16px_50px_-8px_rgba(229,185,75,0.8)] focus-visible:ring-white' : 'bg-verde text-white shadow-[0_10px_40px_-8px_rgba(30,64,175,0.75)] ring-1 ring-gold/40 hover:bg-verde-deep hover:shadow-[0_16px_50px_-8px_rgba(30,64,175,0.9)] focus-visible:ring-gold';
  return <a href={href} className={cn('group inline-flex items-center justify-center gap-2 rounded-xl font-extrabold uppercase tracking-wide transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} style={{
    fontSize: "18px",
    fontWeight: "800",
    width: "300px",
    height: "65px"
  }} data-id="element-51" data-mp="38pjzxbbimc34">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-52" data-mp="1n8nztdfxv4k6" />
    </a>;
}